// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3QmE8","label":"styles_label__2xFLW"};